import CONTRATO_CATALOGO_FAVORITOS from '@/graphql/querys/administracion/contratos/contrato/catalogofavoritos/contratoCatalogoFavoritos.gql';
import CONTRATO_CATALOGO_CONCEPTOS from '@/graphql/querys/administracion/contratos/catalogoConceptos/contratoCatalogoConceptos.gql';
import AGREGAR_CONTRATO_CATALOGO_FAVORITO from '@/graphql/mutations/administracion/contratos/contrato/catalogofavoritos/agregarContratoCatalogosFavoritos.gql';

export default {
  data() {
    return {
    };
  },
  apollo: {
    contratoCatalogoFavoritos: {
      query: CONTRATO_CATALOGO_FAVORITOS,
      variables() {
        return {
          idContrato: this.idContrato,
        };
      },
    },
  },
  methods: {
    async mixAgregarContratoCatalogoFavorito() {
      this.mixEsCargando();
      this.enviandoFormulario = true;

      await this.$apollo
        .mutate({
          mutation: AGREGAR_CONTRATO_CATALOGO_FAVORITO,
          variables: {
            favorito: this.favorito,
          },
          update: (store, { data: { agregarContratoCatalogosFavoritos } }) => {
            const { idConcepto, idContrato } = agregarContratoCatalogosFavoritos;

            // FAVORITOS
            const queryFavoritos = {
              query: CONTRATO_CATALOGO_FAVORITOS,
              variables: {
                idContrato,
              },
            };

            const { contratoCatalogoFavoritos } = store.readQuery(queryFavoritos);
            contratoCatalogoFavoritos.push(agregarContratoCatalogosFavoritos);

            store.writeQuery({ ...queryFavoritos, data: contratoCatalogoFavoritos });

            // CATALOFO
            const queryCatalogo = {
              query: CONTRATO_CATALOGO_CONCEPTOS,
              variables: {
                idContrato: this.idContrato,
              },
            };

            const { contratoCatalogoConceptos } = store.readQuery(queryCatalogo);
            const concepto = contratoCatalogoConceptos.find(({ id }) => id === idConcepto);

            if (concepto) {
              const { favoritos } = concepto;
              favoritos.push(agregarContratoCatalogosFavoritos);
            }

            store.writeQuery({ ...queryCatalogo, data: contratoCatalogoConceptos });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
          this.cerrar();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
      this.mixEsCargando();
    },
  },
};
